const addThousandSeparator = (number: number) => {
  // return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  return Intl.NumberFormat('sv-SE').format(number)
}

export default addThousandSeparator
